export default __webpack_public_path__ + "img/33-75ccaa97.png";